// 柱
import rlModelData from "./rlModelData";
import store from "@/store/index";
import { getEntityById, getEntityData } from "@/rlMxModules/operate/operateApi";
import { rlTextData } from "./rlTextData";
import { McGePoint3d, McDbPolyline, McCmColor } from "mxcad";
import { getPKPM_ColData } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import { calculateDistanceAndAngle } from "@/rlMxModules/operate/operateApi";
import {
  checkRelationGuidData,
  MovePt,
} from "@/rlMxModules/operate/structural";
import { getpickstatus } from "@/api/modelingList.js";
class rlColumnData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_ColData = store.state.globalData.rl_wasm_module.getPKPM_ColData;
  constructor() {
    super();
    this.componentType = "column";
    // 顶点数据
    this.points = [];
    this.Name = null;
    this.deviation = 0;
    this.m_JointData = {}; //关联的节点数据
    // this.m_sectParamData = {}; //柱截面数据
    // this.SectData = []; //柱截面组合数据

    this.EccX = null; //柱的沿轴偏心--沿X轴
    this.EccY = null; //柱的偏轴偏心--沿Y轴
    this.Rotation = null; //柱转角
    this.HDiffB = null; //柱底标高
    this.flrHeight = null; //楼层高度
    this.Attribute = 1; //默认为主要构件,Attribute==2是构造柱
    this.classTypeName = "rlColSeg"; // 柱
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    // this.defaultColor = "#0201f9"; //默认颜色
    this.Color = null;
    // (this.rlLayer && this.rlLayer[1] && this.rlLayer[1].storey) || "#0201f9"; //构件颜色
    // this.Layer = "rlColSeg"; //图层名称
    this.ModelType = "柱";
    this.m_groupName = "rlColumnGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据
    //检测鉴定数据--配筋数据
    this.m_jcData = [];
    //排查--房间命名
    this.useFunctionNames = [];
    //同类构件中主构件的guid
    this.m_RelationGuid = null;
    //同类构件数据--临时保存文字
    this.m_HomogeneousData = [];
    this.m_HomogeneousTextStrData = null; //同类构件中主构件的文字位置偏移
    //检查构件文字--临时保存文字
    this.checkText = null;
  }

  //绘制同类构件文字
  drawHomogeneousData(data, isDisplay) {
    if (this.m_sectParamData.Mat != 6) {
      return;
    }
    if (!data) {
      if (this.m_HomogeneousTextStrData) {
        data = this.m_HomogeneousTextStrData;
      } else {
        return;
      }
    } else {
      this.m_HomogeneousTextStrData = data;
    }
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.eraseHomogeneousData();
    }
    let fontSize = store.state.platBtns.fontSize;
    //矩形柱
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new McGePoint3d(this.index2dData[0], this.index2dData[1], 0);
      let pt2 = new McGePoint3d(this.index2dData[3], this.index2dData[4], 0);
      let pt3 = new McGePoint3d(this.index2dData[6], this.index2dData[7], 0);
      let pt4 = new McGePoint3d(this.index2dData[9], this.index2dData[10], 0);
      let vec1 = new THREE.Vector3().subVectors(pt3, pt2).normalize();
      let vec2 = new THREE.Vector3().subVectors(pt2, pt3).normalize();
      let vec3 = new THREE.Vector3().subVectors(pt1, pt2).normalize();

      if (data.bArea != null) {
        let { angle } = calculateDistanceAndAngle(pt4, pt3);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt4.x + pt3.x) / 2,
          (pt4.y + pt3.y) / 2,
          0
        );
        position = MovePt(position, vec1, fontSize);
        textObj.position = position;
        textObj.Text = data.bArea;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(isDisplay);
        this.m_HomogeneousData.push(textObj.mcDbId);
      }
      if (data.hArea != null) {
        let { angle } = calculateDistanceAndAngle(pt1, pt4);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt1.x + pt4.x) / 2,
          (pt1.y + pt4.y) / 2,
          0
        );
        position = MovePt(position, vec3, fontSize);
        textObj.position = position;
        textObj.Text = data.hArea;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(isDisplay);
        this.m_HomogeneousData.push(textObj.mcDbId);
      }
      if (data.encrypted_report_area != null) {
        let { angle } = calculateDistanceAndAngle(pt1, pt2);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt1.x + pt2.x) / 2,
          (pt1.y + pt2.y) / 2,
          0
        );
        position = MovePt(position, vec2, fontSize);
        textObj.position = position;
        textObj.Text = "G" + data.encrypted_report_area;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(isDisplay);
        this.m_HomogeneousData.push(textObj.mcDbId);
      }
    }
  }

  //删除同类构件文字
  eraseHomogeneousData() {
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.m_HomogeneousData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_HomogeneousData = [];
    }
  }

  //绘制检查构件文字
  async drawCheckText() {
    if (
      store.state.cadModules.rlProject_detail.businessTypePermission ===
      "investigate"
    ) {
      return;
    }
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
    let checkStatus = store.state.inspectionStore.checkStatus;
    if (!checkStatus) {
      return;
    }

    let findCol = checkStatus.find((item) => item.guid == this.Guid);

    if (findCol) {
      let box = new THREE.Box3();
      box.expandByPoint(
        new McGePoint3d(this.index2dData[0], this.index2dData[1], 0)
      );
      box.expandByPoint(
        new McGePoint3d(this.index2dData[3], this.index2dData[4], 0)
      );
      box.expandByPoint(
        new McGePoint3d(this.index2dData[6], this.index2dData[7], 0)
      );
      box.expandByPoint(
        new McGePoint3d(this.index2dData[9], this.index2dData[1], 0)
      );
      let dist = Math.abs(box.min.y - box.max.y);
      let fontSize = store.state.platBtns.fontSize;
      const isShowColumns =
        (this.getCheckStatus(4) && this.Attribute == 1) ||
        (this.getCheckStatus(26) && this.Attribute == 2);
      const isCheckCheckText = this.getCheckStatus(25);
      // console.log("isShowColumns", isShowColumns);
      // console.log("isCheckCheckText", isCheckCheckText);
      let display = isShowColumns && isCheckCheckText;

      // console.log("display", display);
      if (display && findCol.content != "") {
        let pt1 = new McGePoint3d(...this.m_JointData.m_pt);
        pt1.y -= dist / 2;
        let textObj = new rlTextData();
        textObj.position = pt1;
        textObj.Text = "柱(检:" + findCol.content + ")";
        textObj.color = new McCmColor(255, 0, 0);
        textObj.fontSize = fontSize;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(display);
        this.checkText = textObj.mcDbId;
      }
    }
  }

  //删除检查构件文字
  eraseCheckText() {
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
  }

  //根据guid获取checkbox的点击状态
  getCheckStatus(guid) {
    return store.state.displayData.rlLayerDisplay.includes(guid);
  }

  //绘制检测数据
  drawJcData(jcDataObj, bShow, showType /*1==序号，2==配筋 */) {
    if (this.m_sectParamData.Mat != 6 || !jcDataObj) {
      return;
    }

    if (this.m_jcData && this.m_jcData.length) {
      //删除
      this.eraseJcData();
    }
    let fontSize = store.state.platBtns.fontSize;
    //矩形柱
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new THREE.Vector3(this.index2dData[0], this.index2dData[1], 0);
      let pt2 = new THREE.Vector3(this.index2dData[3], this.index2dData[4], 0);
      let pt3 = new THREE.Vector3(this.index2dData[6], this.index2dData[7], 0);
      let pt4 = new THREE.Vector3(this.index2dData[9], this.index2dData[10], 0);
      //若旋转角度大于90度，需要对顶点进行旋转
      if (this.Rotation >= 90) {
        if (this.Rotation < 180) {
          let tmp = pt4;
          pt4 = pt3;
          pt3 = pt2;
          pt2 = pt1;
          pt1 = tmp;
        } else if (this.Rotation < 270) {
          let tmp = pt1;
          pt1 = pt3;
          pt3 = tmp;
          tmp = pt2;
          pt2 = pt4;
          pt4 = tmp;
        } else {
          let tmp = pt4;
          pt4 = pt1;
          pt1 = pt2;
          pt2 = pt3;
          pt3 = tmp;
        }
      }

      let ptCenter = new THREE.Vector3(
        (pt1.x + pt3.x) / 2,
        (pt1.y + pt3.y) / 2,
        0
      );

      if (jcDataObj.No) {
        let textObj = new rlTextData();
        textObj.position = ptCenter;
        textObj.Text = jcDataObj.No;
        textObj.fontSize = fontSize;
        textObj.draw(showType == 1);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.UC) {
        let textObj = new rlTextData();
        textObj.position = new THREE.Vector3(
          pt4.x - fontSize * 2,
          pt4.y + fontSize * 2,
          0
        );
        textObj.Text = "(" + jcDataObj.UC + ")";
        textObj.fontSize = fontSize;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.Asx) {
        let textObj = new rlTextData();
        textObj.position = new THREE.Vector3(
          (pt3.x + pt4.x) / 2,
          (pt3.y + pt4.y) / 2 + fontSize,
          0
        );
        textObj.Text = jcDataObj.Asx;
        textObj.fontSize = fontSize;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.AsC) {
        let lineObj = new McDbPolyline();
        lineObj.addVertexAt(pt3);
        lineObj.addVertexAt(
          new THREE.Vector3(pt3.x + fontSize * 2, pt3.y + fontSize * 2, 0)
        );
        lineObj.addVertexAt(
          new THREE.Vector3(pt3.x + fontSize * 5, pt3.y + fontSize * 2, 0)
        );
        lineObj.visible = showType == 2;
        let objId = rlAppObj.mxcadObject.drawEntity(lineObj);
        this.m_jcData.push(objId);

        let textObj = new rlTextData();
        textObj.position = new THREE.Vector3(
          pt3.x + fontSize * 3,
          pt3.y + fontSize * 3,
          0
        );
        textObj.Text = jcDataObj.AsC;
        textObj.fontSize = fontSize;
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.Asv && jcDataObj.Asv0) {
        let textObj = new rlTextData();
        textObj.position = new THREE.Vector3(
          (pt1.x + pt2.x) / 2,
          (pt1.y + pt2.y) / 2 - fontSize,
          0
        );
        textObj.Text = "G" + jcDataObj.Asv + "-" + jcDataObj.Asv0;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("3")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.fontSize = fontSize;
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.AsVj) {
        let textObj = new rlTextData();
        textObj.position = ptCenter;
        textObj.Text = jcDataObj.AsVj;
        textObj.fontSize = fontSize;
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }

      if (jcDataObj.Asy) {
        let textObj = new rlTextData();
        textObj.position = new THREE.Vector3(
          (pt1.x + pt4.x) / 2 - fontSize * 3,
          (pt1.y + pt4.y) / 2,
          0
        );
        textObj.Text = jcDataObj.Asy;
        textObj.fontSize = fontSize;
        if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("2")) {
          textObj.color = new McCmColor(255, 0, 0);
        }
        textObj.textType = "计算结果";
        textObj.draw(showType == 2);
        this.m_jcData.push(textObj.mcDbId);
      }
    } else {
      if (jcDataObj.dataFrom == "yjk") {
        let points = [];
        for (let i = 0; i < this.index2dData.length; i += 3) {
          points.push(
            new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
          );
        }
        let ptUc = null; //Uc编号位置
        let ptAszAsF = null;
        let ptAsvj = null;
        let ptAsv = null;
        let vecX = new THREE.Vector3(1, 0, 0);
        let vecY = new THREE.Vector3(0, 1, 0);
        //工字型
        if (this.m_sectParamData.Kind == 2) {
        }
        //L型
        else if (this.m_sectParamData.Kind == 28) {
          ptUc = points[2];
          ptAszAsF = points[1];
          ptAsvj = new THREE.Vector3(
            (points[3].x + points[0].x) / 2,
            (points[3].y + points[0].y) / 2,
            0
          );
          ptAsv = points[0];
        }
        //T型
        else if (this.m_sectParamData.Kind == 29) {
          ptUc = points[4];
          ptAszAsF = points[3];
          ptAsvj = new THREE.Vector3(
            (points[2].x + points[5].x) / 2,
            (points[2].y + points[5].y) / 2,
            0
          );
          ptAsv = points[0];
          vecX = new THREE.Vector3(
            points[0].x - points[7].x,
            points[0].y - points[7].y,
            0
          ).normalize();
          vecY = new THREE.Vector3(
            points[1].x - points[0].x,
            points[1].y - points[0].y,
            0
          ).normalize();
        }
        //圆形
        else if (this.m_sectParamData.Kind == 3) {
          let redius = this.m_sectParamData.ShapeVal.split(",")?.[1];
          redius = redius ? Number(redius) : 0;
          let ptJoint = new THREE.Vector3(...this.m_JointData.m_pt);
          ptUc = new THREE.Vector3(
            ptJoint.x - redius / 2,
            ptJoint.y + redius / 2
          );
          ptAszAsF = ptJoint;
          ptAsvj = ptJoint;
          ptAsv = new THREE.Vector3(
            ptJoint.x + redius / 2,
            ptJoint.y - redius / 2
          );

          if (jcDataObj.Astb) {
            let textObj = new rlTextData();
            textObj.position = new THREE.Vector3(
              ptJoint.x,
              ptJoint.y - redius / 2 - fontSize,
              0
            );
            textObj.Text = jcDataObj.Astb;
            textObj.fontSize = fontSize;
            if (
              jcDataObj.ProblemError &&
              jcDataObj.ProblemError.includes("1")
            ) {
              textObj.color = new McCmColor(255, 0, 0);
            }
            textObj.textType = "计算结果";
            textObj.draw(showType == 2);
            this.m_jcData.push(textObj.mcDbId);
          }
        }
        if (jcDataObj.UC && ptUc) {
          let textObj = new rlTextData();
          textObj.position = new THREE.Vector3(
            ptUc.x - fontSize * 2,
            ptUc.y + fontSize * 2,
            0
          );
          textObj.Text = "(" + jcDataObj.UC + ")";
          textObj.fontSize = fontSize;
          if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
            textObj.color = new McCmColor(255, 0, 0);
          }
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          this.m_jcData.push(textObj.mcDbId);
        }
        if (jcDataObj.ASZ && ptAszAsF) {
          let textObj = new rlTextData();
          textObj.position = new THREE.Vector3(
            ptAszAsF.x + vecX.x * fontSize * 4 + vecY.x * fontSize * 4,
            ptAszAsF.y + vecX.y * fontSize * 4 + vecY.y * fontSize * 4,
            0
          );
          textObj.Text = jcDataObj.ASZ;
          textObj.fontSize = fontSize;
          // if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          //   textObj.color = new McCmColor(255, 0, 0);
          // }
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          this.m_jcData.push(textObj.mcDbId);

          let lineObj = new McDbPolyline();
          lineObj.addVertexAt(ptAszAsF);
          lineObj.addVertexAt(
            new THREE.Vector3(
              ptAszAsF.x + vecX.x * fontSize * 2 + vecY.x * fontSize * 2,
              ptAszAsF.y + vecX.y * fontSize * 2 + +vecY.y * fontSize * 2,
              0
            )
          );
          lineObj.addVertexAt(
            new THREE.Vector3(
              ptAszAsF.x + vecX.x * fontSize * 5 + vecY.x * fontSize * 2,
              ptAszAsF.y + vecX.y * fontSize * 5 + +vecY.y * fontSize * 2,
              0
            )
          );
          lineObj.visible = showType == 2;
          let objId = rlAppObj.mxcadObject.drawEntity(lineObj);
          this.m_jcData.push(objId);
        }
        if (jcDataObj.ASF && ptAszAsF) {
          let textObj1 = new rlTextData();
          textObj1.position = new THREE.Vector3(
            ptAszAsF.x + vecX.x * fontSize * 4 + vecY.x * fontSize * 2,
            ptAszAsF.y + vecX.y * fontSize * 4 + vecY.y * fontSize * 2,
            0
          );
          textObj1.Text = jcDataObj.ASF;
          textObj1.fontSize = fontSize;
          // if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          //   textObj.color = new McCmColor(255, 0, 0);
          // }
          textObj.textType = "计算结果";
          textObj1.draw(showType == 2);
          this.m_jcData.push(textObj1.mcDbId);
        }
        if (jcDataObj.AsVj && ptAsvj) {
          let textObj = new rlTextData();
          textObj.position = new THREE.Vector3(ptAsvj.x, ptAsvj.y, 0);
          textObj.Text = jcDataObj.AsVj;
          textObj.fontSize = fontSize;
          // if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          //   textObj.color = new McCmColor(255, 0, 0);
          // }
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          this.m_jcData.push(textObj.mcDbId);
        }
        if (jcDataObj.Asv && ptAsv) {
          let textObj = new rlTextData();
          textObj.position = new THREE.Vector3(
            ptAsv.x + vecX.x * fontSize * 4 - vecY.x * fontSize * 2,
            ptAsv.y + vecX.y * fontSize * 4 - vecY.y * fontSize * 2,
            0
          );
          textObj.Text = "G" + jcDataObj.Asv + "-" + jcDataObj.Asv;
          textObj.fontSize = fontSize;
          // if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
          //   textObj.color = new McCmColor(255, 0, 0);
          // }
          textObj.textType = "计算结果";
          textObj.draw(showType == 2);
          this.m_jcData.push(textObj.mcDbId);
          let lineObj = new McDbPolyline();
          lineObj.addVertexAt(ptAsv);
          lineObj.addVertexAt(
            new THREE.Vector3(
              ptAsv.x + vecX.x * fontSize * 3 - vecY.x * fontSize * 3,
              ptAsv.y + vecX.y * fontSize * 3 - +vecY.y * fontSize * 3,
              0
            )
          );
          lineObj.addVertexAt(
            new THREE.Vector3(
              ptAsv.x + vecX.x * fontSize * 6 - vecY.x * fontSize * 3,
              ptAsv.y + vecX.y * fontSize * 6 - +vecY.y * fontSize * 3,
              0
            )
          );
          lineObj.visible = showType == 2;
          let objId = rlAppObj.mxcadObject.drawEntity(lineObj);
          this.m_jcData.push(objId);
        }
      }
    }
    store.commit("rlEntData/editEntityData", {
      Guid: this.Guid,
      classTypeName: this.classTypeName,
    });
  }

  eraseJcData() {
    if (this.m_jcData && this.m_jcData.length) {
      this.m_jcData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_jcData = [];
    }
  }

  initData(obj) {
    super.initData(obj);
    this.flrHeight = obj.flrHeight;
    this.m_JointData = obj.m_JointData;
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.HDiffB = obj.HDiffB;
    this.points = obj.points;
    this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    this.m_RelationGuid = obj.m_RelationGuid ? obj.m_RelationGuid : null;
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let res = getPKPM_ColData(
        this.m_sectParamData.Kind,
        this.m_sectParamData.ShapeVal,
        this.m_JointData.m_pt[0],
        this.m_JointData.m_pt[1],
        this.LevelB,
        this.flrHeight,
        this.Height,
        this.EccX,
        this.EccY,
        this.Rotation,
        this.HDiffB,
        this.m_JointData.HDiff ? Number(this.m_JointData.HDiff) : 0
      );
      if (!res) return;
      this.getModelDrawData(JSON.parse(res));

      this.OtherData.Height = this.Height.toFixed(0);

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      this.index2dData = this.index2dData.split(",").map(Number);
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["upViewData"];
  //   console.log("this.index2dData", this.index2dData);

  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);

  //   let drawing_3d = modelData["Drawing_3D"];
  //   console.log("drawing_3d", drawing_3d);

  //   this.points = drawing_3d.points;
  //   this.index3dData = {
  //     points: drawing_3d.points,
  //     faces: drawing_3d.faces,
  //   };
  // }

  // 删除
  async erase() {
    if (this.m_JointData && this.m_JointData.m_cloumId) {
      this.m_JointData.m_cloumId = null;
    }
    //撤销回退中不处理关联处理
    if (!store.state.globalData.isReDo) {
      if (
        this.m_JointData &&
        this.m_JointData.m_gridIds &&
        this.m_JointData.m_gridIds.length <= 0
        // &&
        // this.m_AxisIds &&
        // this.m_AxisIds.length <= 0
      ) {
        await this.m_JointData.erase();
      }
    }
    await checkRelationGuidData(this.Guid, "rlColSeg");
    this.eraseJcData(); //清空检测数据
    this.eraseCheckText();
    await super.erase();
  }

  // 克隆方法
  myClone() {
    let newObj = new rlColumnData();
    super.cloneData(newObj);
    newObj.flrHeight = this.flrHeight;
    newObj.m_JointData = this.m_JointData;
    newObj.EccX = this.EccX;
    newObj.EccY = this.EccY;
    newObj.Rotation = this.Rotation;
    newObj.HDiffB = this.HDiffB;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.useFunctionNames = this.useFunctionNames;
    newObj.m_RelationGuid = this.m_RelationGuid;
    return newObj;
  }

  // 绘制
  draw() {
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
      this.CurrtSect = sectString;
    }

    super.draw();
    if (this.m_JointData) {
      this.m_JointData.m_cloumId = this.Guid;
    }
    this.drawCheckText();
  }

  transformBy(vecMove) {
    //计算柱的偏轴和偏心
    if (this.m_sectParamData.Kind == 1) {
      if (this.Rotation == 90) {
        this.EccX += vecMove.y;
        this.EccY -= vecMove.x;
      } else if (this.Rotation == 180) {
        this.EccX -= vecMove.x;
        this.EccY -= vecMove.y;
      } else if (this.Rotation == 270) {
        this.EccX -= vecMove.y;
        this.EccY += vecMove.x;
      } else {
        this.EccX += vecMove.x;
        this.EccY += vecMove.y;
      }
    } else {
      this.EccX += vecMove.x;
      this.EccY += vecMove.y;
    }
    // this.draw();
    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
    // this.updateThisObj(this);
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    if (this.m_JointData) data["JtGuid"] = this.m_JointData.Guid;
    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    data["HDiffB"] = this.HDiffB;
    data["useFunctionNames"] = this.useFunctionNames?.join(",");
    data["RelationGuid"] = this.m_RelationGuid;
    return data;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_JointData = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_JointData,
    });
    if (!this.m_JointData) {
      this.m_JointData = getEntityData({
        classTypeName: "rlJointC",
        Guid: obj.m_JointData,
      });
    }
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.HDiffB = obj.HDiffB;
    this.useFunctionNames = JSON.parse(obj.useFunctionNames);
    this.m_RelationGuid = obj.m_RelationGuid;
    this.flrHeight = obj.flrHeight;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();
    data["m_JointData"] = this.m_JointData.Guid;

    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    data["HDiffB"] = this.HDiffB;
    data["useFunctionNames"] = JSON.stringify(this.useFunctionNames);
    data["RelationGuid"] = this.m_RelationGuid;
    data["flrHeight"] = this.flrHeight;

    return data;
  }
}

export { rlColumnData };
